import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  button: {
    [theme.breakpoints.between('md', 'lg')]: {
      marginTop: 16,
      textAlign: 'left',
    },
  },
}), { name: 'FundBlockedInfo', index: StylesIndexInjections.UI_MOLECULES });
